import React, { useState } from "react";
import emailjs from "emailjs-com";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = ({ data }) => {
  const [formData, setFormData] = useState(initialState);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add loading state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearForm = () => setFormData({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Immediate feedback
    setIsSubmitting(true);
    clearForm(); // Clear form immediately
    
    emailjs
      .sendForm("service_smsqbin", "template_c7dfrgt", e.target, "EB0QR2isxHwa4FqMv")
      .then(
        (result) => {
          console.log("Email sent successfully:", result.text);
          setIsSubmitting(false);
          setShowSuccessMessage(true);
          setTimeout(() => setShowSuccessMessage(false), 2000);
        },
        (error) => {
          console.error("Email sending failed:", error.text);
          setIsSubmitting(false);
          // Restore form data if there's an error
          setFormData(formData);
          alert("Failed to send the message. Please try again.");
        }
      );
  };

  return (
    <div>
      {/* Single popup that changes content based on state */}
      {(isSubmitting || showSuccessMessage) && (
        <div className="success-popup">
          <div className="success-popup-content">
            {isSubmitting ? (
              <>
                <div className="loading-dots">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
                <p>Sending your message...</p>
              </>
            ) : (
              <>
                <i className="fa fa-check-circle" aria-hidden="true"></i>
                <p>Message sent!</p>
              </>
            )}
          </div>
        </div>
      )}

      {/* Contact Section */}
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              
              <form name="sentMessage" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        disabled={isSubmitting} // Disable during submission
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        disabled={isSubmitting} // Disable during submission
                      />
                    </div>
                  </div>
                </div>
                
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={formData.message}
                    onChange={handleChange}
                    disabled={isSubmitting} // Disable during submission
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="btn btn-custom btn-lg"
                  disabled={isSubmitting} // Disable during submission
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa-solid fa-envelope" aria-hidden="true"></i> Email
                </span>
                <a
                  href={`mailto:${data?.email || ""}`}
                  className="email-link"
                >
                  {data?.email || "Loading..."}
                </a>
              </p>
            </div>
          </div>

          {/* Social Links */}
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a 
                      href={data?.linkedin || "#"} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                    >
                      <i 
                        className="fa-brands fa-linkedin" 
                        style={{ color: "#001619", fontSize: "30px" }}
                        aria-hidden="true"
                      />
                    </a>
                  </li>
                  <li>
                    <a 
                      href={data?.instagram || "#"} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <i 
                        className="fa-brands fa-instagram" 
                        style={{ color: "#001619", fontSize: "30px" }}
                        aria-hidden="true"
                      />
                    </a>
                  </li>
                  <li>
                    <a 
                      href={data?.youtube || "#"} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      aria-label="YouTube"
                    >
                      <i 
                        className="fa-brands fa-youtube" 
                        style={{ color: "#001619", fontSize: "30px" }}
                        aria-hidden="true"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div id="footer">
        <div className="container text-center">
          <p>Copyright &copy; 2025 Priori AI. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};
